import React, { useState, useRef } from 'react';
import './Hazard.css'

const HazardAssessmentForm = () => {
    const [hazards, setHazards] = useState([{ hazard: '', risk: '', mitigation: '' }]);
    const [files, setFiles] = useState([]);
    const canvasRef = useRef(null);

    const addHazard = () => {
        setHazards([...hazards, { hazard: '', risk: '', mitigation: '' }]);
    };

    const handleFileUpload = (e) => {
        const newFiles = Array.from(e.target.files);
        setFiles([...files, ...newFiles]);
    };

    const removeFile = (index) => {
        setFiles(files.filter((_, i) => i !== index));
    };

    const clearSignature = () => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form submitted');
    };

    return (
        <div className="container">
            <h1>Pre-Job Hazard Assessment (PHA)</h1>
            <form onSubmit={handleSubmit}>
                <section>
                    <h2>Job Details</h2>
                    <input type="text" placeholder="Job Title/Description" required />
                    <input type="text" placeholder="Work Location" required />
                    <input type="datetime-local" required />
                </section>
                <section>
                    <h2>Job Hazard Analysis</h2>
                    {hazards.map((_, index) => (
                        <div key={index}>
                            <select>
                                <option>Physical Hazard</option>
                                <option>Chemical Hazard</option>
                                <option>Biological Hazard</option>
                                <option>Ergonomic Hazard</option>
                            </select>
                            <select>
                                <option>Low</option>
                                <option>Medium</option>
                                <option>High</option>
                            </select>
                            <textarea placeholder="Describe mitigation steps"></textarea>
                        </div>
                    ))}
                    <button type="button" onClick={addHazard}>Add Hazard</button>
                </section>
                <section>
                    <h2>Document Upload</h2>
                    <input type="file" multiple onChange={handleFileUpload} />
                    {files.map((file, index) => (
                        <div key={index}>
                            <span>{file.name}</span>
                            <button type="button" onClick={() => removeFile(index)}>Remove</button>
                        </div>
                    ))}
                </section>
                <button type="submit">Submit Hazard Assessment</button>
            </form>
        </div>
    );
};

export default HazardAssessmentForm;
